export default __webpack_public_path__ + "static/media/anthony.66ed33a7.jpeg";